export default __webpack_public_path__ + "static/8-776192450545acee6888d129ac6592d8.webp";